import * as yup from 'yup';
import { translate } from '../../../shared/i18n';

export const schemaCovenantCreate = yup.object().shape({
  description: yup
    .string()
    .required(translate('covenantsModal.validation.descriptionRequired')),
});

export const schemaCovenantEdit = yup.object().shape({
  description: yup
    .string()
    .required(translate('covenantsModal.validation.descriptionRequired')),
  status: yup
    .boolean()
    .required(translate('covenantsModal.validation.statusRequired')),
});
